<template>
  <div class="question-tab">
    <p>{{ heading }}</p>
    <div v-if="type == 'interests'" class="button-div">
      <button
        v-for="item in data"
        :key="item"
        @click="handleIntersets(item)"
        :class="
          selectedIntersets.length != 0 && selectedIntersets.includes(item)
            ? 'green-btn'
            : 'default-btn'
        "
      >
        {{ item }}
      </button>
    </div>
    <div v-else-if="type == 'otherInterests'" class="button-div">
      <button
        v-for="item in data"
        :key="item"
        @click="handleOtherIntersets(item)"
        :class="
          otherInterests && otherInterests.includes(item)
            ? 'green-btn'
            : 'default-btn'
        "
      >
        {{ item }}
      </button>
    </div>
    <div v-else-if="type == 'location'" class="button-div">
      <button
        v-for="item in data"
        :key="item.id"
        @click="handlelocations(item.id)"
        :class="
          selectedStatesId.includes(item.id) ? 'green-btn' : 'default-btn'
        "
      >
        {{ item.eng_name }}
      </button>
    </div>
    <div v-else-if="type == 'crops'" class="button-div">
      <button
        v-for="item in data"
        @click="handleCrops(item)"
        :key="item.id"
        :class="selectedCrops.includes(item.id) ? 'green-btn' : 'default-btn'"
        :disabled="selectedCropTypeId.includes(item.crop_type) ? true : false"
      >
        {{ item.eng_title }}
      </button>
    </div>
    <div v-else-if="type == 'brands'" class="button-div">
      <button
        v-for="item in data"
        :key="item.id"
        @click="handleClick(item)"
        :class="
          selectedStatesId.includes(item.id) ? 'green-btn' : 'default-btn'
        "
      >
        {{ item.name }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "multipleButton",
  data() {
    return {
      clicked: false,
      selectedStatesId: [],
      selectedIntersets: [],
      otherInterests: [],
      selectedCrops: [],
      temp: [],
      componentKey: 0,
      selectedCropTypeId: [],
    };
  },
  props: {
    heading: String,
    type: String,
    data: Array,
    stateId: Object,
    cropType: String,
  },
  mounted() {
    // console.log(this.data);
  },
  watch: {
    "$store.state": {
      handler(newVal, oldVal) {
        console.log("State changed:", newVal, oldVal);
      },
      deep: true,
    },
  },
  created() {
    this.selectedIntersets = this.$store.getters[
      "crmFilters/GET_INTERESTS_DATA"
    ]
      ? this.$store.getters["crmFilters/GET_INTERESTS_DATA"]
      : [];
    this.otherInterests = this.$store.getters[
      "crmFilters/GET_OTHER_INTERESTS_DATA"
    ]
      ? this.$store.getters["crmFilters/GET_OTHER_INTERESTS_DATA"]
      : [];
    this.selectedCrops = this.$store.getters["crmFilters/GET_CROPS_ID_DATA"]
      ? this.$store.getters["crmFilters/GET_CROPS_ID_DATA"]
      : [];
    this.selectedCropTypeId = this.$store.getters[
      "crmFilters/GET_ALL_SELECTED_CROPS_TYPE_ID"
    ]
      ? this.$store.getters["crmFilters/GET_ALL_SELECTED_CROPS_TYPE_ID"]
      : [];
    // console.log(' this.$store.getters["crmFilters/GET_OTHER_INTERESTS_DATA"]', this.$store.getters["crmFilters/GET_OTHER_INTERESTS_DATA"]);
    //   console.log(' this.$store.getters["crmFilters/GET_INTERESTS_DATA"]', this.$store.getters["crmFilters/GET_INTERESTS_DATA"]);
  },
  watch: {
    "$store.state": {
      handler(newVal, oldVal) {
        // Handle state change
        console.log("State changed:", newVal, oldVal);
        this.selectedCrops = this.$store.getters["crmFilters/GET_CROPS_ID_DATA"]
          ? this.$store.getters["crmFilters/GET_CROPS_ID_DATA"]
          : [];
      },
      deep: true, // Watch for nested changes if applicable
    },
  },
  methods: {
    handleClick(item) {
      // this.clicked = !this.clicked;
      console.log("item", item);
      if (!this.selectedStatesId.includes(item.id))
        this.selectedStatesId.push(item.id);
      else {
        const index = this.selectedStatesId.indexOf(item.id);
        if (index > -1) {
          // only splice this.selectedStatesId when item is found

          this.selectedStatesId.splice(index, 1); // 2nd parameter means remove one item only
        }
      }

      console.log("states", this.selectedStatesId);
    },
    handleIntersets(item) {
      console.log("item", item);
      if (!this.selectedIntersets.includes(item))
        this.selectedIntersets.push(item);
      else {
        const index = this.selectedIntersets.indexOf(item);
        if (index > -1) {
          this.selectedIntersets.splice(index, 1); // 2nd parameter means remove one item only
        }
      }
      this.$store.dispatch("crmFilters/setInterests", this.selectedIntersets);

      console.log("states", this.selectedIntersets);
    },
    handlelocations(item) {
      const data = console.log("item", item);
      if (!this.selectedStatesId.includes(item))
        this.selectedStatesId.push(item);
      else {
        const index = this.selectedStatesId.indexOf(item);
        if (index > -1) {
          this.selectedStatesId.splice(index, 1); // 2nd parameter means remove one item only
        }
      }
      const getdata = [
        { distrcits: this.selectedStatesId, state: this.stateId },
      ];
      this.$store.getters["crmFilters/GET_BRANDS_DATA"];
      // getdata.push(getdata)
      this.$store.dispatch("crmFilters/setSlecetdDistrits", getdata);
    },
    handleOtherIntersets(item) {
      console.log("item", item);
      if (!this.otherInterests.includes(item)) this.otherInterests.push(item);
      else {
        const index = this.otherInterests.indexOf(item);
        if (index > -1) {
          this.otherInterests.splice(index, 1); // 2nd parameter means remove one item only
        }
      }
      this.$store.dispatch("crmFilters/setOtherInterests", this.otherInterests);
      console.log("otherInterests", this.otherInterests);
    },
    handleCrops(val) {
      console.log("item", val);
      const CropDataFromStore =
        this.$store.getters["crmFilters/GET_CROPS_FORMATTED_DATA"];
      const cropTypeIds =
        this.$store.getters["crmFilters/GET_SELECTED_CROPS_TYPE_ID"];
      CropDataFromStore.map((item, index) => {
        if (item.crop_type_id == val.crop_type) {
          if (!item.crops.includes(val.id)) {
            item.crops.push(val.id);
            item.isSelect = true;
            cropTypeIds.push(val.crop_type);
            this.selectedCropTypeId.push(val.crop_type_id);
          } else {
            const indexofCropId = item.crops.indexOf(val.id);
            if (indexofCropId !== -1) {
              item.crops.splice(indexofCropId, 1);
              console.log("item.crops.lenght", item.crops.length);
              if (item.crops.length == 0) {
                item.isSelect = false;

                // const indexofCropType = cropTypeIds.indexOf(val.crop_type);
                // if (indexofCropType !== -1) {
                //   indexofCropType.splice(indexofCropId, 1);
                // }
              }
            }
          }
        }
      });
      const CropIds = this.$store.getters["crmFilters/GET_CROPS_ID_DATA"];
      if (!CropIds.includes(val.id)) {
        CropIds.push(val.id);
      } else {
        const index = CropIds.indexOf(val.id);
        // if (index > -1) {
        CropIds.splice(index, 1); // 2nd parameter means remove one item only
        // }
      }
      this.$store.dispatch("crmFilters/setCropsId", CropIds);
      this.$store.dispatch("crmFilters/setCropsFormatted", CropDataFromStore);
      this.$store.dispatch("crmFilters/setCropsTyepId", cropTypeIds);
      this.$store.dispatch(
        "crmFilters/setIsAllCropsTypeIdSelected",
        this.selectedCropTypeId
      );

      console.log("CropDataF", CropDataFromStore);
      this.selectedCrops = this.$store.getters["crmFilters/GET_CROPS_ID_DATA"]
        ? this.$store.getters["crmFilters/GET_CROPS_ID_DATA"]
        : [];
    },
  },
};
</script>
<style lang="scss" scoped>
.question-tab {
  display: flex;
  flex-direction: column;
  margin-left: 28px;
  // margin-top:28px;
  //row-gap: 24px;
  overflow-y: scroll;
  p {
    margin: 0;
  }
}
.button-div {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  //height: 100px;
}
.default-btn {
  height: 35px;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #efefef;
  color: #4b4b4b;
  padding: 8px 12px;
  border-radius: 4px;
}
.green-btn {
  height: 35px;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #efefef;
  color: #189d3b;
  background: #f3faf5;
  padding: 8px 12px;
  border-radius: 4px;
}
</style>
